<template>
  <div class="job-listings-container">
    <p class="job-listings-text">大手企業の求人閲覧やスカウト希望ができます。</p>
    <button class="job-listings-button" @click.prevent="goToJobListings">
      求人を見る
    </button>
  </div>
</template>

<script>
export default {
  name: "ScoutProfile",
  methods: {
    goToJobListings() {
      this.$router.push("/job-listings");
    },
  },
};
</script>

<style scoped>
.job-listings-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 10px;
  background-color: #fff;
}

.job-listings-button {
  background-color: white;
  color: #006C6B;
  border: 2px solid #006C6B;
  border-radius: 4px;
  padding: 10px 20px;
  width: 233px;
  height: 50px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.job-listings-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.job-listings-text {
  margin-top: 10px;
  font-size: 12px;
  color: #3c3c3c;
  text-align: center;
}

@media (max-width: 768px) {
  .job-listings-button {
    font-size: 16px;
  }
}
</style>
